export function toggleAccordion(e) {
    const link = this.closest('[data-accordion-link]');
    const parent = link.closest('[data-accordion]');
    const content = parent.querySelectorAll('[data-accordion-content]');

    content.forEach(function(content) {
        if (content.previousElementSibling === link) {
            content.classList.toggle('is-active');
            link.classList.toggle('is-active');
            link.setAttribute('aria-expanded', link.getAttribute('aria-expanded') === 'true' ? 'false' : 'true');
        }
        else {
            if(!("accordionAllowMultiple" in content.parentNode.dataset)) {
                content.classList.remove('is-active');
                content.previousElementSibling.classList.remove('is-active');
                content.previousElementSibling.setAttribute('aria-expanded', 'false');
            }
        }
    });
}

export function bindEvent(el, eventName, eventHandler) {
    if (el.addEventListener){
        el.addEventListener(eventName, eventHandler, false);
    } else if (el.attachEvent){
        el.attachEvent('on'+eventName, eventHandler);
    }
}